import axios from 'axios';
import { db, Orchard } from '../db';

/**
 * Orchard Synchronization Service
 * Handles fetching the full orchard registry from the backend and 
 * persisting it to the local IndexedDB (Dexie) for offline availability.
 */

export const syncOrchards = async (): Promise<boolean> => {
  if (!navigator.onLine) {
    console.warn('[OrchardSync] Device is offline. Skipping orchard synchronization.');
    return false;
  }

  try {
    const baseUrl = process.env.REACT_APP_API_URL || '/api/v1';
    
    console.log('[OrchardSync] Starting orchard synchronization...');
    
    const response = await axios.get(`${baseUrl}/orchards`, {
      withCredentials: true
    });
    
    if (!Array.isArray(response.data)) {
      throw new Error('Invalid orchard data received from server');
    }

    const timestamp = new Date().toISOString();
    const orchards: Orchard[] = response.data.map((o: any) => ({
      id: o._id || o.id,
      orchardName: o.orchardName,
      farmName: o.farmName,
      location: o.location,
      boundary: o.boundary,
      cultivar: o.cultivar,
      variety: o.variety,
      activePetalFallDate: o.activePetalFallDate || null,
      lastUpdated: timestamp
    }));

    // Atomic clear and update using Dexie transaction
    await db.transaction('rw', db.orchards, async () => {
      await db.orchards.clear();
      await db.orchards.bulkPut(orchards);
    });

    console.log(`[OrchardSync] Successfully synchronized ${orchards.length} orchards.`);
    return true;
  } catch (err) {
    console.error('[OrchardSync] Failed to synchronize orchards:', err);
    return false;
  }
};
